import { IconLogout as TablerIconLogout } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconLogout = /*#__PURE__*/ createOutlineIcon(TablerIconLogout, 'IconLogout');
